import { Box, InputBase, InputBaseProps, useTheme } from '@mui/material'
import { Search as SearchIcon, Close as CloseIcon } from '@mui/icons-material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface SearchInputProps extends InputBaseProps {}

export const SearchInput = ({ ...props }: SearchInputProps) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const [inputValue, setInputValue] = useState('')

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)

    if (props.onChange) {
      props.onChange(e)
    }
  }

  const handleClearInput = () => {
    setInputValue('')

    const event = {
      target: { value: '' },
    } as React.ChangeEvent<HTMLInputElement>

    if (props.onChange) {
      props.onChange(event)
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        height: 40,
        borderRadius: 2,
        paddingLeft: 2,
        backgroundColor: theme.palette.grey[200],
        boxShadow: 'none',
        border: `1px solid ${theme.palette.grey[300]}`,
        ...props.sx,
      }}
    >
      <SearchIcon sx={{ color: theme.palette.text.disabled, mr: 1 }} />
      <InputBase
        {...props}
        placeholder={t('Search in menu')}
        fullWidth
        sx={{
          '& .MuiInputBase-input': {
            ...theme.typography.body1,
          },
        }}
        value={inputValue}
        onChange={handleInputChange}
      />
      {inputValue && (
        <CloseIcon
          sx={{
            color: theme.palette.text.disabled,
            mr: 1,
            cursor: 'pointer',
          }}
          onClick={handleClearInput}
        />
      )}
    </Box>
  )
}
